var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSfu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8361 6.51204C14.8361 7.06802 15.291 7.51873 15.8522 7.51873H20.9838C21.545 7.51873 22 7.96944 22 8.52541V13.9933C22 14.5493 21.545 15 20.9838 15H15.2424C14.6811 15 14.2262 14.5493 14.2262 13.9933V8.92804C14.2262 8.37206 13.7712 7.92135 13.21 7.92135H8.78996C8.22875 7.92135 7.7738 8.37206 7.7738 8.92804V13.9933C7.7738 14.5493 7.31885 15 6.75764 15H1.01616C0.454949 15 0 14.5493 0 13.9933V8.52541C0 7.96944 0.454949 7.51873 1.01616 7.51873H6.04613C6.60734 7.51873 7.06229 7.06802 7.06229 6.51204V1.00668C7.06229 0.450708 7.51724 0 8.07845 0H13.8199C14.3811 0 14.8361 0.450708 14.8361 1.00668V6.51204Z",
    fill: "#4C56E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfu);
export default __webpack_public_path__ + "static/media/sfu.78dcacb37b13c87d5332f22c77908f88.svg";
export { ForwardRef as ReactComponent };